import { UserRole } from "tm-shared/types";

const FIELD_WORKER_ROLES: UserRole[] = [UserRole.Ta, UserRole.Md];

export const isFieldWorkerRole = (role: UserRole): boolean => {
    if (!role) return false;

    return FIELD_WORKER_ROLES.includes(role);
};
